/** Address helpers every page shares: comparison and the short form. */

import { getAddress } from "viem";
import { shortHash } from "./format";

const ADDRESS = /^0x[0-9a-fA-F]{40}$/;
const ZERO = /^0x0{40}$/;

/** "0x" and 40 hexadecimal characters. */
export function isAddress(value: string): boolean {
  return ADDRESS.test(value.trim());
}

export function isZeroAddress(value: string): boolean {
  return ZERO.test(value.trim());
}

/** Case-insensitive; never true when either side is missing. */
export function sameAddress(a: string | null | undefined, b: string | null | undefined): boolean {
  return a !== null && a !== undefined && b !== null && b !== undefined && a.toLowerCase() === b.toLowerCase();
}

/** The EIP-55 form of an address, or the input when it is not one. */
export function checksum(address: string): string {
  try {
    return getAddress(address);
  } catch {
    return address;
  }
}

/** "0xA41c…77d2": EIP-55, even when a wallet hands the address over in lowercase. */
export function shortAddr(address: string): string {
  return shortHash(checksum(address), 4);
}
